module.exports = __webpack_public_path__ + "img/angles-right.515b6ec4.svg";